import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { CompanyDetails } from "../../data/component/models-interfaces/manage-company/company-interface";
@Injectable({
  providedIn: "root",
})
export class SubSytemService {
  constructor(private httpClient: HttpClient) {}

  getAllSubSystemList(page: any, limit: any, search?: any) {
    const apiUrl = `${environment.serverEndPoint}/sub-system/list?page=${page}&limit=${limit}&search=${search}`;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getSubSystem(id: any) {
    const apiUrl = `${environment.serverEndPoint}/sub-system/` + id;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  createSubSystem(data: any) {
    const apiUrl = `${environment.serverEndPoint}/sub-system/create`;
    return this.httpClient.post<CompanyDetails>(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  updateSubSystem(id: any, data: any) {
    const apiUrl = `${environment.serverEndPoint}/sub-system/update/` + id;
    return this.httpClient.put(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  deleteSubSystem(id: any, data: boolean) {
    const sendData = { isDeleted: data };
    const apiUrl = `${environment.serverEndPoint}/sub-system/status-update/` + id;
    return this.httpClient.put(apiUrl, sendData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getDropdownSubSystem() {
    const apiUrl = `${environment.serverEndPoint}/sub-system/dropdown/list`;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      }
    });
  }
}
